import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t, i18n } = useTranslation();

  const [type, setType] = useState<"admin" | "wps">("wps");

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const type = JSON.parse(user).type;

      if (type === "admin") setType("admin");
    }
  }, []);

  if (type === "admin") {
    return (
      <div className="w-full min-h-[calc(100%-72px)] bg-[#f6f5fe] flex flex-col items-center py-[150px]">
        <div className="text-brand-500 text-center">
          <div className="text-36 font-700 mb-[16px]">Page not found</div>
          <div className="text-20 mb-[8px]">
            The page you access does not exist
          </div>
          <div className="text-20">
            Please contact your Administrator for assistance
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-[calc(100%-72px)] bg-[#f6f5fe] flex flex-col items-center py-[150px]">
      <div className="text-brand-500 text-center">
        <div className="text-36 font-700 mb-[16px]">{t("page-not-found")}</div>
        <div className="text-20 mb-[8px]">{t("access-not-found-page")}</div>
        <div className="text-20">{t("support-not-found-page")}</div>
      </div>
    </div>
  );
};

export default NotFound;
